import {
  ApolloClient,
  ApolloProvider,
  HttpLink,
  InMemoryCache,
  createHttpLink,
  from,
} from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { getCookie } from 'utils/cokie'
import getErrorLink from './errorlinks'
import { v4 as uuidv4 } from 'uuid'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useAppDispatch } from 'hooks/redux-hooks'
import { consoleLog } from 'utils/Logger'

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_GRAPHQL_URL,
  credentials: 'same-origin',
})

const httpLink1 = new HttpLink({
  uri: process.env.REACT_APP_GRAPHQL_URL,
})

const authLink = setContext((_, context) => {
  const { headers = {}, isAuthRequired = true } = context || {}
  // get the authentication token from local storage if it exists
  const token = getCookie('access_token')

  // Log warning when token is null for auth-required calls
  if (isAuthRequired && !token) {
    consoleLog('[AuthLink] Warning: Token is null/undefined for auth-required request. User may need to re-login.')
    // Redirect to login if token is missing for auth-required calls
    // This prevents "Bearer null" from being sent
    if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
      consoleLog('[AuthLink] Redirecting to login due to missing token')
      window.location.href = '/login'
    }
    return {
      headers: {
        ...headers,
        'X-IDEMPOTENCY-ID': uuidv4(),
      },
    }
  }

  // return the headers to the context so httpLink can read them
  if (isAuthRequired && token) {
    return {
      headers: {
        ...headers,
        'x-access-token': `Bearer ${token}`,
        'X-IDEMPOTENCY-ID': uuidv4(),
      },
    }
  }
  return {
    headers: {
      ...headers,
    },
  }
})
let client

export const getApolloAuthClient = () => {
  const client = new ApolloClient({
    link: from([authLink.concat(httpLink)]),
    cache: new InMemoryCache({
      addTypename: false,
    }),
  })

  return client
}
export const getApolloClient = (dispatch, navigate) => {
  if (!client) {
    const errorLink = getErrorLink(dispatch, navigate)

    client = new ApolloClient({
      link: from([errorLink, authLink.concat(httpLink1)]),
      cache: new InMemoryCache({
        addTypename: false,
      }),
      defaultOptions: {
        watchQuery: {
          fetchPolicy: 'network-only', // Used for first execution
          nextFetchPolicy: 'network-only',
        },
      },
    })
  }
  return client
}
export default function ApolloClientProvider({ children }) {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const apolloClient = getApolloClient(dispatch, navigate)
  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>
}
